// Persist a corner anchor or floating coordinates, never a viewport-specific
// corner offset. Snapped panels then follow resizing and content growth.
const CORNERS = new Set(["top-left", "top-right", "bottom-left", "bottom-right"]);

export function normalizePanelPosition(value) {
  if (CORNERS.has(value?.corner)) return { corner: value.corner };
  if (Number.isFinite(value?.left) && Number.isFinite(value?.top)) {
    return { left: value.left, top: value.top };
  }
  return { corner: "top-left" };
}

export function resolvePanelPosition(position, bounds) {
  if (CORNERS.has(position.corner)) {
    return {
      left: position.corner.endsWith("right") ? bounds.maxLeft : bounds.minLeft,
      top: position.corner.startsWith("bottom") ? bounds.maxTop : bounds.minTop,
    };
  }
  return {
    left: Math.max(bounds.minLeft, Math.min(position.left, bounds.maxLeft)),
    top: Math.max(bounds.minTop, Math.min(position.top, bounds.maxTop)),
  };
}

export function snapPanelPosition(left, top, bounds, threshold = 32) {
  const point = resolvePanelPosition({ left, top }, bounds);
  const right = bounds.maxLeft - point.left < point.left - bounds.minLeft;
  const bottom = bounds.maxTop - point.top < point.top - bounds.minTop;
  const dx = right ? bounds.maxLeft - point.left : point.left - bounds.minLeft;
  const dy = bottom ? bounds.maxTop - point.top : point.top - bounds.minTop;
  if (dx <= threshold && dy <= threshold) {
    return { corner: `${bottom ? "bottom" : "top"}-${right ? "right" : "left"}` };
  }
  return point;
}
